module.exports = function noop() {
    return noop;
};
